import { render, staticRenderFns } from "./email-history.vue?vue&type=template&id=884651f2&scoped=true"
import script from "./email-history.vue?vue&type=script&lang=js"
export * from "./email-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884651f2",
  null
  
)

export default component.exports